import React, { Fragment } from 'react';
import { number } from 'prop-types';
import { currency } from '@olxbr/mojo-jojo/utils/string';

const Price = ({ value = 0.00 }) => (
  <Fragment>
    {currency(value)}
  </Fragment>
);

Price.propTypes = {
  value: number.isRequired,
};

export default Price;
